import { useAdExplorerStore } from "@/stores/AdExplorer";
import { useTaskStore } from "@/stores/TaskStore";
import { useErrorStore } from "@/stores/ErrorStore";

export const AdExplorerStores = [useAdExplorerStore, useErrorStore];

export const AdExplorerChannel = {
  async received(payload) {
    // Raw-data export completion (success or error) is handled by the shared
    // export manager, which downloads the standardized `payload.data.files`.
    // Must run before the generic error branch below (which returns early) so
    // export loading state always clears.
    if (await this.adExplorerStore.handleExportMessage(payload)) {
      return;
    }
    if (payload.status === "error" || payload.data?.status === "error") {
      const task = Object.keys(this.adExplorerStore.taskIds).find(
        (task) => this.adExplorerStore.taskIds[task] === payload.id,
      );
      if (task) {
        this.adExplorerStore.taskIds[task] = undefined;
        this.adExplorerStore.loading[task] = false;
        if (task in this.adExplorerStore.errors) {
          this.adExplorerStore.errors[task] = payload.message;
        } else {
          this.errorStore.showError(payload.message);
        }
      }
      return;
    }
    if (payload.id === this.adExplorerStore.taskIds.dateRange) {
      this.adExplorerStore.loading.dateRange = false;
      this.adExplorerStore.dates = {
        minDate: payload.data.dates.min_date
          ? new Date(payload.data.dates.min_date).toISOString()
          : undefined,
        maxDate: payload.data.dates.max_date
          ? new Date(payload.data.dates.max_date).toISOString()
          : undefined,
      };
      this.adExplorerStore.taskIds.dateRange = undefined;
    }
    if (payload.id === this.adExplorerStore.taskIds.races) {
      this.adExplorerStore.loading.races = false;
      this.adExplorerStore.races = payload.data;
      this.adExplorerStore.taskIds.races = undefined;
    }
    if (payload.id === this.adExplorerStore.taskIds.sponsors) {
      this.adExplorerStore.loading.sponsors = false;
      this.adExplorerStore.sponsors = payload.data;
      this.adExplorerStore.taskIds.sponsors = undefined;
    }
    if (payload.id === this.adExplorerStore.taskIds.networkStations) {
      this.adExplorerStore.loading.networkStations = false;
      this.adExplorerStore.networkStations = payload.data;
      this.adExplorerStore.taskIds.networkStations = undefined;
    }
    if (payload.id === this.adExplorerStore.taskIds.creatives) {
      this.adExplorerStore.loading.creatives = false;
      this.adExplorerStore.creatives = payload.data;
      this.adExplorerStore.taskIds.creatives = undefined;
      if (this.adExplorerStore.filters.creative_ids?.length) {
        this.adExplorerStore.filters.creative_ids =
          this.adExplorerStore.filters.creative_ids
            ?.map((creative_id) => {
              if (
                this.adExplorerStore.creatives.find((c) => c.id === creative_id)
              ) {
                return creative_id;
              }
            })
            .filter((i) => i !== undefined);
      }
    }
    if (payload.id === this.adExplorerStore.taskIds.overview) {
      this.adExplorerStore.loading.overview = false;
      this.adExplorerStore.overview = payload.data;
      this.adExplorerStore.taskIds.overview = undefined;
    }
    if (payload.id === this.adExplorerStore.taskIds.creativesBreakdown) {
      this.adExplorerStore.loading.creativesBreakdown = false;
      this.adExplorerStore.creativesBreakdown = payload.data.creatives;
      this.adExplorerStore.taskIds.creativesBreakdown = undefined;
    }
    if (payload.id === this.adExplorerStore.taskIds.dailyStats) {
      this.adExplorerStore.loading.dailyStats = false;
      this.adExplorerStore.dailyStats = payload.data;
      this.adExplorerStore.taskIds.dailyStats = undefined;
    }
  },
};

export const cancelTasks = async () => {
  const adExplorerStore = useAdExplorerStore();
  const taskStore = useTaskStore();
  const tasks = [
    "dateRange",
    "categories",
    "races",
    "sponsors",
    "networkStations",
    "creatives",
    "overview",
    "creativesBreakdown",
    "dailyStats",
  ];
  const activeTasks = tasks.filter((key) => adExplorerStore.taskIds[key]);
  const cancel = activeTasks.map(async (key) => {
    const taskId = adExplorerStore.taskIds[key];
    await taskStore.cancelTask(taskId);
    adExplorerStore.taskIds[key] = undefined;
    adExplorerStore.loading[key] = false;
  });
  await Promise.all(cancel);
};
